import api from '../api/axios';
import { store } from '../store';
import { updateUserMenu } from '../content/auth/slice';

/**
 * Fetch latest user menu permissions and ordering from backend,
 * and dispatch immediately to Redux store so Header navbar updates in real time
 * without requiring the user to log out and log back in.
 */
let isRefreshing = false;
let lastRefreshTime = 0;

export const refreshUserMenu = async (force: boolean = false): Promise<boolean> => {
    const now = Date.now();
    if (!force && now - lastRefreshTime < 2000) {
        return false;
    }
    if (isRefreshing) return false;
    isRefreshing = true;
    lastRefreshTime = now;

    try {
        const state = store.getState();
        const token = state.Auth?.user?.token || (typeof localStorage !== 'undefined' ? localStorage.getItem('authToken') : null);
        if (!token) {
            isRefreshing = false;
            return false;
        }

        const response = await api.get('/users/current-menu');
        const { roleMenuList, showHome, showTracking } = response.data;

        if (Array.isArray(roleMenuList)) {
            const currentMenu = state.Auth?.user?.roleMenuList;
            const currentHome = state.Auth?.user?.showHome;
            const currentTracking = state.Auth?.user?.showTracking;

            const isChanged =
                JSON.stringify(roleMenuList) !== JSON.stringify(currentMenu) ||
                showHome !== currentHome ||
                showTracking !== currentTracking;

            if (isChanged) {
                store.dispatch(updateUserMenu({ roleMenuList, showHome, showTracking }));
            }

            return true;
        }
        return false;
    } catch (error) {
        console.warn('Failed to refresh user menu in background:', error);
        return false;
    } finally {
        isRefreshing = false;
    }
};
